<template>
  <div class='dialog-content'>
    <div class="kye-dialog-body">
      <kye-form :model="form" ref="form" label-width="64px" class="demo-form">
        <kye-form-item label="姓名/工号" prop="userName"
          :rules="$rule.str('姓名/工号不能为空', true, 'change')">
          <kye-search-tips
            style="width: 200px;"
            v-model="form.userName"
            placeholder="输入工号/姓名"
            url="data.employee.listByName"
            value-key="chineseName"
            :format-data="formatData"
            @select="item => handleSelect(item)">
          </kye-search-tips>
        </kye-form-item>
      </kye-form>
    </div>
    <div class="el-dialog__footer">
      <kye-button type="primary" @click="save">保 存(S)</kye-button>
      <kye-button @click="close">取 消</kye-button>
    </div>
  </div>
</template>
<script>
 export default {
  data() {
    return {
      form: {
        userName: ''
      },
      selectItem: {}
    }
  },
  methods: {
    formatData (val) {
      if (!val || val.length < 2) return
      let data = null
      if (/^\d{6,}$/.test(val)) {
        data = { employeeNumber: val, status: '10' }
      } else {
        data = { chineseName: val, status: '10' }
      }
      return data
    },
    async handleSelect (item) {
      if (!item) return
      this.selectItem = item
    },
    async save() {
      if (this.selectItem) {
        const res = await this.getUserOpenId(this.selectItem.employeeNumber)
        console.log(res)
        this.$emit('setUser', {
          employeeNumber: this.selectItem.employeeNumber,
          name: this.selectItem.chineseName,
          position: this.selectItem.position,
          openId: res[this.selectItem.employeeNumber]
        })
        this.close()
        this.selectItem = {}
      } else {
        this.$message.warning('请选择用户')
      }
    },
    async getUserOpenId(userNumber) {
      const res = await this.$http('iaa.user.getOpenId', {
        employeeNumberList: [userNumber]
      })
      return res
    },
    close() {
      this.$emit('close')
    }
  }
 }
</script>
<style lang="scss" scoped>
.dialog-content {
  .kye-dialog-body {
    padding: 32px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-editor-new/components/search-user.vue